import { useTranslation } from "react-i18next";
import { ChevronLeft } from "lucide-react";
import { cn } from "../util/cn";
import { Button } from "./ui/button";

type BackButtonProps = React.ComponentProps<"button"> & {
    hidden: boolean;
};

const BackButton = ({ hidden, className, ...rest }: BackButtonProps) => {
  const { t } = useTranslation();

  if (hidden) {
    return null;
  }

  return (
    <Button
      {...rest}
      variant="ghost"
      size="sm"
      className={cn("flex flex-row items-center gap-1 text-foreground/90", className)}
    >
      <ChevronLeft size={16} strokeWidth={2.25} aria-hidden="true" className="shrink-0" />
      <span className="text-foreground font-normal ">{t("general.back")}</span>
    </Button>
  );
};

export default BackButton;
